var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import EmptyComponent from 'components/EmptyComponent';
import DataTable from 'library/components/DataTable';
import { buttonColumn, chipColumn, codeColumn, monoColumn, mutedColumn } from 'library/components/DataTable/cells';
import ListScreen, { ListAddButton, ListExportButton, listPager } from 'library/components/ListScreen';
import { Transaction as TransactionResource } from 'constants/resources';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { downloadCsv, todayStamp } from 'pages/inventory/csv';
import services from 'services';
import ExpenseDrawer from './components/ExpenseDrawer';
var EXPORT_LIMIT = 100;
var Transactions = function (props) {
    var _a, _b, _c, _d;
    var t = props.translate;
    var navigate = useNavigate();
    var transactionService = services.transactionService, permissionService = services.permissionService;
    var _e = useState(1), pageNumber = _e[0], setPageNumber = _e[1];
    var _f = useState(''), searchValue = _f[0], setSearchValue = _f[1];
    var _g = useState(false), expenseOpen = _g[0], setExpenseOpen = _g[1];
    var _h = useState(false), exporting = _h[0], setExporting = _h[1];
    var debounceRef = useRef(undefined);
    var canAdd = permissionService.hasPermissionToAdd(TransactionResource);
    var canShow = permissionService.hasPermissionToShow(TransactionResource);
    var _j = transactionService.useTransactions(pageNumber), data = _j.data, isLoading = _j.isLoading;
    var transactions = useMemo(function () {
        var query = searchValue.trim().toLowerCase();
        var rows = (data === null || data === void 0 ? void 0 : data.transactions) || [];
        if (!query)
            return rows;
        return rows.filter(function (transaction) {
            var _a, _b;
            var haystack = [
                transaction.getCode(),
                transaction.getDisplayedStatus(),
                (_a = transaction.getDocument()) === null || _a === void 0 ? void 0 : _a.getName(),
                (_b = transaction.getClinic()) === null || _b === void 0 ? void 0 : _b.getName(),
                String(transaction.getId())
            ].join(' ').toLowerCase();
            return haystack.includes(query);
        });
    }, [data === null || data === void 0 ? void 0 : data.transactions, searchValue]);
    var total = Number(((_a = data === null || data === void 0 ? void 0 : data.meta) === null || _a === void 0 ? void 0 : _a.count) || 0);
    var from = Number(((_b = data === null || data === void 0 ? void 0 : data.meta) === null || _b === void 0 ? void 0 : _b.from) || 0);
    var to = Number(((_c = data === null || data === void 0 ? void 0 : data.meta) === null || _c === void 0 ? void 0 : _c.to) || 0);
    var pages = Math.max(1, Number(((_d = data === null || data === void 0 ? void 0 : data.meta) === null || _d === void 0 ? void 0 : _d.pages) || 1));
    var exportTransactions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var pageData, latest, rows, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (exporting)
                        return [2 /*return*/];
                    setExporting(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, transactionService.fetchTransactionsPage(1, { items: EXPORT_LIMIT })];
                case 2:
                    pageData = _b.sent();
                    latest = (pageData.transactions || []).slice(0, EXPORT_LIMIT);
                    if (latest.length === 0) {
                        message.warning(t('exportEmpty'));
                        return [2 /*return*/];
                    }
                    rows = __spreadArray([
                        [t('id'), t('code'), t('amount'), t('status'), t('document'), t('clinic'), t('transactionDate')]
                    ], latest.map(function (transaction) {
                        var _a, _b;
                        return [
                            String(transaction.getId()),
                            transaction.getCode() || '',
                            String(t('common:price', { amount: transaction.getAmount() })),
                            transaction.getDisplayedStatus() || '',
                            ((_a = transaction.getDocument()) === null || _a === void 0 ? void 0 : _a.getName()) || '',
                            ((_b = transaction.getClinic()) === null || _b === void 0 ? void 0 : _b.getName()) || '',
                            transaction.getFormattedTransactionDate() || ''
                        ];
                    }), true);
                    downloadCsv("transactions-latest-".concat(EXPORT_LIMIT, "-").concat(todayStamp(), ".csv"), rows);
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    message.error(t('exportFailed'));
                    return [3 /*break*/, 5];
                case 4:
                    setExporting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onSearchValueChange = function (event) {
        var value = event.target.value;
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(function () { return setSearchValue(value); }, 300);
    };
    var columns = useMemo(function () { return __spreadArray([
        monoColumn({ key: 'id', title: t('id'), width: '72px', value: function (transaction) { return transaction.getId(); } }),
        codeColumn({ key: 'code', title: t('code'), width: '120px', value: function (transaction) { return transaction.getCode(); } }),
        monoColumn({
            key: 'amount',
            title: t('amount'),
            width: '130px',
            align: 'end',
            variant: 'strong',
            value: function (transaction) { return t('common:price', { amount: transaction.getAmount() }); }
        }),
        chipColumn({ key: 'status', title: t('status'), width: '150px', tone: 'is-sky', value: function (transaction) { return transaction.getDisplayedStatus(); } }),
        mutedColumn({ key: 'document', title: t('document'), width: 'minmax(160px, 1.2fr)', value: function (transaction) { var _a; return (_a = transaction.getDocument()) === null || _a === void 0 ? void 0 : _a.getName(); } }),
        mutedColumn({ key: 'clinic', title: t('clinic'), width: 'minmax(140px, 1fr)', value: function (transaction) { var _a; return (_a = transaction.getClinic()) === null || _a === void 0 ? void 0 : _a.getName(); } }),
        mutedColumn({ key: 'date', title: t('transactionDate'), width: 'minmax(170px, 1.1fr)', value: function (transaction) { return transaction.getFormattedTransactionDate(); } })
    ], (canShow ? [buttonColumn({
            title: t('action'),
            accent: true,
            label: t('common:buttons.show'),
            onClick: function (transaction) { return navigate("/transactions/".concat(transaction.getId())); }
        })] : []), true); }, [t, canShow, navigate]);
    return (_jsxs(ListScreen, { title: t('header.transactions'), count: t('countBadge', { count: total }), subtitle: t('subtitle'), actions: (_jsxs(_Fragment, { children: [_jsx(ListExportButton, { label: t('export'), busyLabel: t('exporting'), busy: exporting, onClick: exportTransactions }), canAdd ? (_jsx(ListAddButton, { onboarding: true, label: t('common:buttons.newExpense'), onClick: function () { return setExpenseOpen(true); } })) : null] })), search: { placeholder: t('searchPlaceholder'), onChange: onSearchValueChange }, children: [_jsx(DataTable, { compact: true, minWidth: "1120px", loading: isLoading, rows: transactions, rowKey: function (transaction) { return transaction.getId(); }, empty: _jsx(EmptyComponent, { description: t('empty') }), columns: columns, pager: listPager({
                    total: total,
                    page: pageNumber,
                    pages: pages,
                    meta: t('showingRange', { from: from, to: to, total: total }),
                    previous: t('previous'),
                    next: t('next'),
                    center: t('pageOf', { page: pageNumber, pages: pages }),
                    setPage: setPageNumber
                }) }), canAdd && (_jsx(ExpenseDrawer, { visiable: expenseOpen, onCloseDrawer: function () { return setExpenseOpen(false); } }))] }));
};
export default localeTranslator(Transactions, 'transactions');
